import * as React from 'react';
import { ReactChild, ReactChildren } from 'react';

type CenteredPanelWithOverlayProps = {
    opened: boolean
    classes: string
    children: ReactChild | ReactChild[] | ReactChildren | ReactChildren[],
}

function CenteredPanelWithOverlay({
    opened,
    classes,
    children
}: CenteredPanelWithOverlayProps) {
    return (
        <div className={`centered-panel-with-overlay ${opened && 'opened'} ${classes && classes}`}>
            {children}
        </div>
    );
}

export default CenteredPanelWithOverlay;
